"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESULT_DIALOG_CLOSE_BUTTON = exports.RESULT_DIALOG = void 0;
const RESULT_DIALOG = exports.RESULT_DIALOG = 'result-dialog';
const RESULT_DIALOG_CLOSE_BUTTON = exports.RESULT_DIALOG_CLOSE_BUTTON = 'result-dialog-close-button';
